// STYLES
import { useEffect, useState } from "react";
import * as Style from "./DiscountsStyle";

// LIBRARIES
import { useTranslation } from "react-i18next";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";

// MISC
import { ButtonTypes, InputTypes, ModalTypes } from "models/GeneralTypes/generalTypes";
import { FiltersComponentOptions } from "config/FiltersComponentOptions";

// ASSETS
import ClockIcon from "assets/Icons/TimeIcon.svg";
import AddIcon from "assets/Icons/AddSupport.svg";
import PersonDefaultIcon from "assets/Icons/defaultPersonPhoto.jpg";

// REDUX
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";

// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import SelectAtom from "components/Atoms/SelectAtom/SelectAtom";
import InputAtom from "components/Atoms/InputAtom/InputAtom";
import { toggleModalState } from "slices/uiSlice";
import dayjs from "dayjs";
import { createPromoCode, getPromoCodes } from "api/promoCodeApi";
import { setUsersListState, usersList } from "slices/promoCodesSlice";
import { ICreatePromoCode } from "models/interfaces";
import { InputAtomTypes } from "components/Atoms/InputAtom/InputAtomModel";

const Discounts = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const promoCodeUsers = useAppSelector(usersList);

  // CONSTANTS USING HOOKS
  const [selectedPromoCodeOption, setSelectedPromoCodeOption] = useState<string>("");
  const [value, setValue] = useState<string>("")
  const [isGlobalUsageSelected, setIsGlobalUsageSelected] = useState<boolean>(true);
  const [isNominallUsageSelected, setIsNominalUsageSelected] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [displayedPromoCodes, setDisplayedPromoCodes] = useState([]);
  const [usersListData, setUsersListData] = useState([])

  // GENERAL CONSTANTS
  const {
    promoCodeTypeOptions
  } = FiltersComponentOptions();

  // USE EFFECT FUNCTION
  useEffect(() => {
    console.log({ promoCodeUsers })
    let payload = {
      page: "0",
    }
    dispatch(getPromoCodes(payload))
      .unwrap()
      .then((response) => {
        setDisplayedPromoCodes(response.content)
        setCurrentPage(currentPage + 1);
      })
  }, []);

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const getPromoCodeData = () => {
    let payload = {
      page: currentPage,
    }
    dispatch(getPromoCodes(payload))
      .unwrap()
      .then((response) => {
        console.log(response.content)
        setDisplayedPromoCodes([...displayedPromoCodes, ...response.content])
        setCurrentPage(currentPage + 1);
      });
  };

  const handleSelectUsers = () => {
    dispatch(setUsersListState([]));
    dispatch(
      toggleModalState({
        isVisible: true,
        type: ModalTypes.SELECT_USERS,
      })
    );
  };

  const handleScrollEnd = (e: React.UIEvent<HTMLDivElement>) => {
    const divElement = e.target as HTMLDivElement;
    const { scrollTop, scrollHeight, clientHeight } = divElement;
    if (scrollTop + clientHeight === scrollHeight) {
      getPromoCodeData();
    }
  };

  const handleEditPromoCode = (promoCode) => {
    dispatch(
      toggleModalState({
        isVisible: true,
        type: ModalTypes.EDIT_PROMO_CODE,
        promoCode: promoCode
      })
    );
  };

  const handleGeneratePromoCode = () => {
    setIsLoading(true);
    let usersIds = [];
    if (isNominallUsageSelected) {
      usersIds = promoCodeUsers.map(user => user.id);
    }
    console.log({ usersIds })
    let payload: ICreatePromoCode = {
      amount: parseInt(value),
      discountType: selectedPromoCodeOption,
      type: isGlobalUsageSelected ? "GLOBAL" : "NOMINAL",
      userIds: usersIds
    }
    console.log({ payload })
    dispatch(createPromoCode(payload))
      .unwrap()
      .then((response) => {
        console.log("createPromoCode", response)
        getPromoCodeData();
        setIsLoading(false);
      })
      .catch(err => {
        console.log(err)
        setIsLoading(false);
      })
  }

  const handleToggleUsageTab = () => {
    setIsGlobalUsageSelected(!isGlobalUsageSelected);
    setIsNominalUsageSelected(!isNominallUsageSelected);
    setSelectedPromoCodeOption("");
    setValue("");
    dispatch(setUsersListState([]))
  }
  console.log({ displayedPromoCodes })
  return (
    <Style.Container>
      <Style.SendNotificationsContainer>
        <Style.Title>
          Add Promo Code
        </Style.Title>
        <Style.Bar />
        <Style.ContentContainer>
          <Style.ContentWrapper>
            <Style.LeftContainer>
              <Style.DicountType isSelected={isGlobalUsageSelected} onClick={() => handleToggleUsageTab()}>
                Global usage
              </Style.DicountType>
              <Style.DicountType isSelected={isNominallUsageSelected} onClick={() => handleToggleUsageTab()}>
                Nominal usage
              </Style.DicountType>
            </Style.LeftContainer>
            <Style.RightContainer>
              <Style.SecondLine>
                <Style.InputAtomContainer width="220px">
                  <SelectAtom
                    options={promoCodeTypeOptions}
                    selectedOptions={selectedPromoCodeOption}
                    setSelectedOptions={(e) =>
                      setSelectedPromoCodeOption(e)
                    }
                    label={"Promo-code type"}
                  />
                </Style.InputAtomContainer>
                <Style.InputAtomContainer2 width="120px">
                  <InputAtom
                    placeholder={"Scrie"}
                    label={"The amount"}
                    inputValue={value}
                    setInputValue={(value) =>
                      setValue(value)
                    }
                    type={InputTypes.MODAL_INPUT}
                  />
                </Style.InputAtomContainer2>
              </Style.SecondLine>
              {isNominallUsageSelected && <Style.ThirdLine>
                <Style.Subtitle>
                  Select the users who will receive the nominal discount
                </Style.Subtitle>
                <Style.AddUsersRow>
                  <Style.AddCategory onClick={() => handleSelectUsers()}>
                    <Style.ImageContainer src={AddIcon} alt="" />
                    Add users
                  </Style.AddCategory>
                  {promoCodeUsers.length !== 0 && <Style.NumberOfUsers>
                    {`${promoCodeUsers.length} users added`}
                  </Style.NumberOfUsers>}
                </Style.AddUsersRow>
                {(isNominallUsageSelected && promoCodeUsers.length !== 0) &&
                  <Style.UsersList>
                    {promoCodeUsers &&
                      promoCodeUsers.map((user, index) => {
                        return (
                          <Style.UserContainer>
                            <Style.UserIcon src={PersonDefaultIcon} />
                            <Style.UserName>
                              {user?.fullName || "NO_NAME_PROVIDED"}
                            </Style.UserName>
                          </Style.UserContainer>
                        )
                      })
                    }
                  </Style.UsersList>
                }
              </Style.ThirdLine>}
              <Style.ButtonContainer>
                <ButtonAtom
                  text={"Genereaza"}
                  type={isLoading ? ButtonTypes.DISABLED : ButtonTypes.MAIN_BUTTON}
                  onClick={() => handleGeneratePromoCode()}
                  width="169px"
                />
              </Style.ButtonContainer>
            </Style.RightContainer>
          </Style.ContentWrapper>
        </Style.ContentContainer>
      </Style.SendNotificationsContainer>
      <Style.NotificationsListContainer>
        <Style.Title>
          Promo-code List
        </Style.Title>
        <Style.Bar2 />
        <Style.NotificationsContainer onScroll={handleScrollEnd}>
          <Style.PromoCodeSubtitle>
            Promo-code Active:
          </Style.PromoCodeSubtitle>
          {displayedPromoCodes &&
            displayedPromoCodes.map((promoCode) => {
              return (
                promoCode.isValid && <Style.NotificationContainer>
                  <Style.PromoCodeInfo>
                    <Style.NotificationTitle>
                      {promoCode.code}
                    </Style.NotificationTitle>
                    <Style.PromoCodeType>
                      {promoCode.type === "GLOBAL" ? "Global Usage" : "Nominal Usage"}
                    </Style.PromoCodeType>
                  </Style.PromoCodeInfo>

                  <Style.NotificationDateContainer>
                    <Style.ClockIconImage src={ClockIcon} />
                    <Style.NotificationDate>
                      {dayjs(promoCode.creationDate).format(
                        "HH:mm DD.MM.YYYY"
                      )}{" "}
                    </Style.NotificationDate>
                  </Style.NotificationDateContainer>
                  <MoreVertOutlinedIcon fontSize="small" onClick={() => handleEditPromoCode(promoCode)} />
                </Style.NotificationContainer>
              );
            })}
          <Style.PromoCodeSubtitle>
            Promo-code Inactive:
          </Style.PromoCodeSubtitle>
          {displayedPromoCodes &&
            displayedPromoCodes.map((promoCode) => {
              return (
                (!promoCode.isValid) && <Style.NotificationContainer>
                  <Style.PromoCodeInfo>
                    <Style.InactiveTitle>
                      {promoCode.code}
                    </Style.InactiveTitle>
                    <Style.InactivePromoCodeType>
                      {promoCode.type === "GLOBAL" ? "Global Usage" : "Nominal Usage"}
                    </Style.InactivePromoCodeType>
                  </Style.PromoCodeInfo>

                  <Style.NotificationDateContainer>
                    <Style.ClockIconImage src={ClockIcon} />
                    <Style.NotificationDate>
                      {dayjs(promoCode.creationDate).format(
                        "HH:mm DD.MM.YYYY"
                      )}{" "}
                    </Style.NotificationDate>
                  </Style.NotificationDateContainer>
                  <MoreVertOutlinedIcon fontSize="small" onClick={() => handleEditPromoCode(promoCode)} />
                </Style.NotificationContainer>
              );
            })}
        </Style.NotificationsContainer>
      </Style.NotificationsListContainer>
    </Style.Container>
  );
};



export default Discounts;
